<div class="logs-editable-filter">
    <cds-tag
        *ngIf="!isEditing"
        class="logs-editable-filter__tag"
        status="info"
        size="20"
    >
        <div class="logs-editable-filter__tag-container">
            <div
                class="logs-editable-filter__tag-content"
                (click)="openFilter()"
            >
                {{ filter }}
            </div>
            <cds-icon
                class="logs-editable-filter__tag-close-icon"
                shape="times"
                size="16"
                (click)="onFilterRemove.emit()"
            ></cds-icon>
        </div>
    </cds-tag>
    <logs-filter-input
        *ngIf="isEditing"
        [isEditable]="true"
        (onSubmit)="updateFilter()"
        (onKeydown)="handleKeydown($event)"
    ></logs-filter-input>
</div>
